import { DatePipe } from "@angular/common";
import dayjs from "dayjs";

const datePipe = new DatePipe('en');

export function getJustDate(date: Date = new Date()): Date {
    let d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}
export function formatDate(date?: Date | null): string {
    return datePipe.transform(date, 'yyyy-MM-dd') || '';
}

export function stringToLocalDate(date: string): Date {
    return new Date(date + "T00:00:00"); // Month is 0-indexed in JavaScript Date
}

export function dateOnlyToDate(date: string): Date {

    const [year, month, day] = date!.split('-').map(Number);
    const d = new Date(year, month - 1, day);
    return d;
}
export function ago(date?: Date | null): string {
    if (!date) return '';

    // Convert input to a timestamp
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    // Guard clause for future dates or slight system clock mismatches
    if (seconds < 29) return 'Ahora';

    // Define time intervals in seconds
    const intervals: { [key: string]: number } = {
        'año': 31536000,
        'mes': 2592000,
        'semana': 604800,
        'día': 86400,
        'hora': 3600,
        'minuto': 60,
        'segundo': 1
    };

    let counter;
    for (const unit in intervals) {
        counter = Math.floor(seconds / intervals[unit]);
        if (counter > 0) {
            if (counter === 1) {
                return `${counter} ${unit} atrás`; // Singular (e.g., 1 day ago)
            } else {
                if (unit == 'mes')
                    return `${counter} ${unit}es atrás`; // Plural (e.g., 3 months ago)

                return `${counter} ${unit}s atrás`; // Plural (e.g., 3 days ago)
            }
        }
    }
    return 'Ahora';
}



export function formatTime(date?: Date | null): string {
    return datePipe.transform(date, 'HH:mm') || '';
}

export function formatDateTime(date?: Date | null): string {
    return datePipe.transform(date, 'yyyy-MM-dd HH:mm') || '';
}

export function toStartDate(date: dayjs.Dayjs): dayjs.Dayjs {
    return date.startOf('day');
}

export function toEndDate(date: dayjs.Dayjs): dayjs.Dayjs {
    return date.endOf('day');
}

export function dayOfWeekFromShort(dow: string): string {
    if (dow == "Dom")
        return "Domingo";
    if (dow == "Lun")
        return "Lunes";
    if (dow == "Mar")
        return "Martes";
    if (dow == "Mie")
        return "Miércoles";
    if (dow == "Jue")
        return "Jueves";
    if (dow == "Vie")
        return "Viernes";
    if (dow == "Sab")
        return "Sábado";
    return dow;
}